<template>
     <div>
        
  <!-- Navigation -->
   <!-- <mheader></mheader> -->
  <!-- <header>
    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
      </ol>
      <div class="carousel-inner" role="listbox"> -->
        <!-- Slide One - Set the background image for this slide in the line below -->
        <!-- <div class="carousel-item active" style="background-image: url('../../static/images/0001.jpg')">
          
        </div> -->
        <!-- Slide Two - Set the background image for this slide in the line below -->
        <!-- <div class="carousel-item" style="background-image: url('../../static/images/0002.jpg')">
          
        </div> -->
        <!-- Slide Three - Set the background image for this slide in the line below -->
        <!-- <div class="carousel-item" style="background-image: url('../../static/images/0003.jpg')">
          
        </div>
        <div class="carousel-item" style="background-image: url('../../static/images/0004.jpg')">
          
        </div>
      </div>
      <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </header> -->

  <!-- Page Content -->
    <div v-show="news.length>0&&list.length>0" class="card p-2" style="width:1300px;margin:0 auto;margin-top:50px;margin-bottom:50px;box-shadow: 10px 10px 5px #888888;">
     
    <!-- Marketing Icons Section -->
    <div class="row mt-3">
      <div class="col-lg-8 mb-4">
        <div class="inform">
          <h4 class="inform-h text-center" style="color:red;">团购药品招商</h4>
          <div class="inform-content">
            <p class="mt-lg-3" style="text-indent:30px;line-height:50px;color:red;font-size:25px;">
              为提高商城流量、增加销售额，助力于各位代理商有效清理库存。现针对商业公司推出“团购”活动，薄利多销，寻求稳定优质下游客户。需寻找药品一批，用于团购使用。有意者请致电8496677、18158821390。欢迎您的来电，望我们合作共赢。</p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="memeber">
          <h4 class="memeber-h">
            通知通告
              <img src="../../static/images/tongzhi.png" style="width:30px;height:30px;" alt="">
              <router-link to="/moreMessage" class="" style="float:right">更多</router-link>
          </h4>
          <div class="pt-3" v-for="(item,index) in list" :key="index">
            <p>
              <router-link :to="{path:'/myM',query:{id:item._id.$oid}}">{{item.articleName}}</router-link>
              <span style="float:right;">
                {{item.uptime.$date.$numberLong | getData}}
              </span>
            </p>
            <p class="border_to mt-2" style="text-align:right;">
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->

     <!-- 华源新闻 -->
     
     <h2 class="mb-3 p-3" style="border-bottom:2px solid #3190e8;color:#3190e8">
        华源新闻
     </h2>
     
      <div class="row mb-2">
         <div class="col-lg-6">
                  <div class="ml-lg-3">
              <ul class="list-unstyled">
              <li v-for="(item,index) in news" :key="index">
                   <div v-if="index<10">
                      <p class="text-left mt-3 ellipsis">
                           <!-- <router-link :to="{path:'/newsList',query:{id:item._id.$oid}}">{{item.articleName}}</router-link> -->
                           <router-link :to="{path:'/newsList'}">
                           <span @click="getContent(item)">
                             {{item.title}}
                           </span>
                           </router-link>
                      </p>
                      <p style="border-bottom:1px dashed rgba(0,0,0,0.5);text-align:right;">
                           <span>
                             {{item.addDate}}
                           </span>
                      </p>
                   </div>
              </li>
           </ul>
          </div>
         </div>
         <div class="col-lg-6">
              <div class="ml-lg-3">
              <ul class="list-unstyled">
              <li v-for="(item,index) in news" :key="index">
                   <div v-if="index>=10">
                      <p class="text-left mt-3 ellipsis">
                           <!-- <router-link :to="{path:'/newsList',query:{id:item._id.$oid}}">{{item.articleName}}</router-link> -->
                           <router-link :to="{path:'/newsList'}">
                           <span @click="getContent(item)">
                             {{item.title}}
                           </span>
                           </router-link>
                      </p>
                      <p style="border-bottom:1px dashed rgba(0,0,0,0.5);text-align:right;">
                           <span>
                               {{item.addDate}}
                           </span>
                      </p>
                   </div>
              </li>
           </ul>
          </div>
         </div>
           
     </div>
    
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>


    <!-- Call to Action Section -->
    
    </div>
     </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Loading from '../components/Loading.vue'
export default {
  name:'Index',
  data(){
    return {
           news:[],
           list:[],
           isLoading:false,
          
    }
  },
  computed:{
       ...mapState(['newList'])
  },
  filters:{
      getData(data){
          var date=new Date(parseInt(data))
          
        var dateTime = date.toLocaleString();
             return dateTime
      }
  },
   components:{
        // mheader,
        // mfooter,
        // Loading

    },
    methods:{
      //获取内容
        getContent(item){
            this.NEW_LIST(item);
            // 
        },
         ...mapMutations(["NEW_LIST"]),
         change(){
             $("#tozh").addClass("d-none")
         },
        getList: async function () {
            //  this.isLoading=true;
        const {data: res} = await this.$http.get("http://124.112.116.187:8066/News/news",{
              
        })
        // 
         let that=this;
         that.news=res.data;
        //  that.NEW_LIST()
        //  that.isLoading=false;
      },
        getMR: async function () {
        //  this.isLoading=true;
        const {data: res} = await this.$http.post('http://220.179.91.17:8072/Home/getMR', 
          {groupid:window.sessionStorage.getItem("groupid")}
        )
        // 
        if (res.isOk) {
             let that=this;
             that.list=res.mesg;
            //  that.isLoading=false;
             
        }
      },
    
    },
    created(){
             this.getList()
              this.getMR()
            
    }
}
</script>
<style scoped>
  .fo{
    font-size:15px;
  }
  .ng{
    background-color:#ffff;
  }
  .wh{
     width:200px;
     height:150px;
  }
  .border_to{
      border-bottom:1px solid rgba(0,0,0,0.5)
  }
  .header_container{
     width:100%;
     height:60px;
    background-color:#fff;
  }
  .nav_left{
    background-color:#fff;
  }
  .ellipsis{
    width:600px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue